import { useLocation } from "react-router"
import CaesarAIUniAdmin from "./caesaraiuniadmin";
import { useState } from "react";
export default function AuthCaesarAIUniAdmin(){
    let location = useLocation();
    const [authed,setAuthed] = useState(location.state === null ? false: location.state.authed === "true" ? true : false)
    return(
        <div>
            {authed === true ? 
            <CaesarAIUniAdmin/>
            :
            <div><h1>Amari CaesarAIUniAdmin Unauthorized</h1></div>}
        </div>

    )
}